import React from 'react';
import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';

import { NavItem } from './NavItem';
import { NavContainer } from './NavContainer';
import { NavOuterContainer } from './NavOuterContainer';
import { HStack } from '@chakra-ui/react';

function recursivelyGroupChildren(children: any, groupedChildren: any) {
  React.Children.map(children, (child) => {
    if (child === null) {
      return null;
    }
    if (!get(child, 'props.isNavigationItem')) {
      if (!isEmpty(get(child, 'props.children'))) {
        return recursivelyGroupChildren(child.props.children, groupedChildren);
      }

      return null;
    }
    const { props } = child;
    groupedChildren[props.variant].push(child);
    return null;
  });
}

export const Navigation = ({ children, className, style, id }: any) => {
  const groupedChildren = {
    left: [],
    center: [],
    right: [],
  };

  recursivelyGroupChildren(children, groupedChildren);

  return (
    <NavOuterContainer
      className={`h-center ${className}`}
      style={style}
      id={id}
    >
      <NavContainer className={className}>
        <HStack w="auto" spacing={0} gap={[4, 4, 8]} pl={6}>
          {groupedChildren.left}
        </HStack>
        <HStack w="auto" className="h-center" spacing={0} gap={[4, 4, 8]}>
          {groupedChildren.center}
        </HStack>
        <HStack w="auto" className="h-end" spacing={0} gap={[4, 4, 8]} pr={6}>
          {groupedChildren.right}
        </HStack>
      </NavContainer>
    </NavOuterContainer>
  );
};

Navigation.Item = NavItem;
Navigation.displayName = 'Navigation';
